import axios from 'axios'
import { API } from 'src/feature/bite/domain'

interface CountryListResponse {
  response: {
    countries: {
      id: string
      name: string
      englishName: string
      code: string
      code2: string
      exCode: string
      flag: string
    }[]
  }
}

export default async function getCountries() {
  const response = await axios.post<CountryListResponse>(
    `${API}/Country/GetCountries`,
    {}
  )
  return response.data.response.countries
}